const fromdata = [
  {
    title: "第一季度",
    data: [
      {
        inputdata: 1,
        title: "一月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
        min: 1,
        max: 1000,
        lablewith: "100px",
      },
      {
        inputdata: 1,
        title: "二月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
        min: 1,
        max: 1000,
        lablewith: "100px",
      },
      {
        inputdata: 1,
        title: "三月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
        min: 1,
        max: 1000,
        lablewith: "100px",
      },
    ],
  },
  {
    title: "第二季度",
    data: [
      {
        inputdata: 1,
        title: "四月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
		min: 1,
        max: 1000,
        lablewith: "100px",
      },
      {
        inputdata: 1,
        title: "五月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
		min: 1,
        max: 1000,
        lablewith: "100px",
      },
      {
        inputdata: 1,
        title: "六月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
        min: 1,
        max: 1000,
        lablewith: "100px",
      },
    ],
  },
  {
    title: "第三季度",
    data: [
      {
        inputdata: 1,
        title: "七月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
        min: 1,
        max: 1000,
        lablewith: "100px",
      },
      {
        inputdata: 1,
        title: "八月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
        min: 1,
        max: 1000,
        lablewith: "100px",
      },
      {
        inputdata: 1,
        title: "九月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
        min: 1,
        max: 1000,
        lablewith: "100px",
      },
    ],
  },
  {
    title: "第四季度",
    data: [
      {
        inputdata: 1,
        title: "十月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
        min: 1,
        max: 1000,
        lablewith: "100px",
      },
      {
        inputdata: 1,
        title: "十一月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
		min: 1,
        max: 1000,
        lablewith: "100px",
      },
      {
        inputdata: 1,
        title: "十二月指标",
        fontSize: "14px",
        color: "#333333",
        placeholder: "",
        types: "",
        inputtype: "numbertowCQ",
        width: "190px",
		min: 1,
        max: 1000,
        lablewith: "100px",
      },
    ],
  },
];
export default fromdata;
